import React from 'react';
type Tone = 'light' | 'dark' | 'sand';
const toneClasses: Record<Tone, string> = {
  light: 'bg-polar text-oceano',
  sand: 'bg-[#F3F0E8] text-oceano',
  dark: 'bg-oceano text-polar'
};
export function Section({
  id,
  children,
  tone = 'light',
  className = ''
}: {
  id?: string;
  children: React.ReactNode;
  tone?: Tone;
  className?: string;
}) {
  return <section id={id} className={`${toneClasses[tone]} w-full ${className}`} data-id="element-190" data-mp="2r47zirypmnf9">
      <div className="mx-auto w-full max-w-content px-5 sm:px-8" data-id="element-191" data-mp="35t44gg5gzkbn">{children}</div>
    </section>;
}
export function SectionHeader({
  eyebrow,
  title,
  intro,
  tone = 'light',
  className = ''
}: {
  eyebrow?: string;
  title: React.ReactNode;
  intro?: React.ReactNode;
  tone?: 'light' | 'dark';
  className?: string;
}) {
  return <div className={`mx-auto max-w-[42rem] text-center ${className}`} data-id="element-192" data-mp="1khm8gfdph9xt">
      {eyebrow && <p className={`font-sans text-[10px] font-medium uppercase tracking-[0.24em] sm:text-[11px] ${tone === 'dark' ? 'text-travertino' : 'text-caribe'}`} data-id="element-193" data-mp="1kjoxaw34gx0y">
          {eyebrow}
        </p>}
      <h2 className={`font-display font-bold leading-[1.16] ${eyebrow ? 'mt-3.5' : ''} text-[26px] sm:text-[34px] lg:text-[38px] ${tone === 'dark' ? 'text-polar' : 'text-oceano'}`} data-id="element-194" data-mp="24n2z2zvamwam">
        {title}
      </h2>
      {intro && <p className={`mx-auto mt-4 max-w-[38rem] font-sans text-[13.5px] leading-relaxed sm:text-[14.5px] ${tone === 'dark' ? 'text-polar/65' : 'text-hierro'}`} data-id="element-195" data-mp="2ehmim8h0o7sm">
          {intro}
        </p>}
    </div>;
}